import { useEffect, useRef, useState } from 'react';
import { TimeLineDataType } from '../../services/apiTypes';
import SnipzPost from '../Feed/SnipzPost';
import { CarouselContainer, Container } from './styles';

type SnipzCarouselProps = {
  leftSelected: string;
  itemData: TimeLineDataType[];
}

export default function SnipzCarousel({ leftSelected, itemData }: SnipzCarouselProps) {
  const [currentIndex, setCurrentIndex] = useState(0);
  const CarouselRef = useRef<HTMLDivElement>(null);

  const handleWheel = (e: any) => {
    e.preventDefault();
    if (e.deltaY < 0 && currentIndex > 0) { // Scrolling up
      setCurrentIndex(currentIndex - 1);
    } else if (e.deltaY > 0 && currentIndex <= itemData.length) { // Scrolling down
      setCurrentIndex(currentIndex + 1);
    }
  };

  useEffect(() => {
    const container = document.querySelector('#carouselContainer');
    container?.addEventListener('wheel', handleWheel);

    return () => {
      container?.removeEventListener('wheel', handleWheel);
    };
  }, [currentIndex, itemData.length]);

  return (
    <Container id="carouselContainer">
      <CarouselContainer
        ref={CarouselRef}
        style={{ transform: `translateY(-${((currentIndex * 89.05) + 5)}vh)` }}
      >
        {itemData && itemData.map((item, index) => (
          <div
            key={item.id}
            style={{ display: 'flex', justifyContent: 'center' }}
          >
            {item.type === "snipz" &&
              <SnipzPost
                index={index}
                authorAvatarUrl={item.authorAvatarUrl}
                authorId={item.authorId}
                authorUsername={item.authorUsername}
                id={item.id}
                feedType='snipz'
                type={item.type}
                medias={item.medias}
                description={item.description}
                tags={item.tags}
                likes={item.likes}
                comments={item.comments}
                createdAt={item.createdAt}
                updatedAt={item.updatedAt}
                isLiked={item.isLiked}
                carouselIndex={currentIndex}
              />}
          </div>
        ))}
      </CarouselContainer>
    </Container>
  )
}